import Microgame from '../engine/Microgame.js';

export default class TypeGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Tape !`, en: `Type!`, es: `¡Teclea!` },
            controls: { fr: `Appuie sur les lettres du clavier à l'écran`, en: `Tap the letters on the on-screen keyboard`, es: `Toca las letras en el teclado de la pantalla` },
            objective: { fr: `Écris le mot demandé sans faire de faute`, en: `Type the required word without mistakes`, es: `Escribe la palabra pedida sin cometer errores` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2" ry="2"/><path d="M6 8h.01M10 8h.01M14 8h.01M18 8h.01M8 12h.01M12 12h.01M16 12h.01M7 16h10"/></svg>`,
            actions: [
                { type: 'wait', duration: 320 },
                { type: 'tapTarget', selector: '[data-playback-key="1"]', duration: 220 },
                { type: 'wait', duration: 120 },
                { type: 'tapTarget', selector: '[data-playback-key="2"]', duration: 220 },
                { type: 'wait', duration: 120 },
                { type: 'tapTarget', selector: '[data-playback-key="3"]', duration: 220 },
                { type: 'wait', duration: 600 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.code = '';
        this.input = '';

        // --- GAME PARAMETERS ---
        this.duration = 5000; // Base time in ms
        this.baseCodeLength = 3; // Base number of digits
        // -----------------------

        this.codeLength = this.baseCodeLength;
        this.inputDisplay = null;
    }

    setup() {
        this.engine.ui.instruction.textContent = "TYPE!";

        this.container.style.display = 'flex';
        this.container.style.flexDirection = 'column';
        this.container.style.alignItems = 'center';
        this.container.style.justifyContent = 'center';
        this.container.style.height = '100%';

        // Scale difficulty based on speed multiplier
        const speedMult = this.engine.speedMultiplier || 1.0;
        if (speedMult <= 2.0) {
            this.codeLength = 3;
        } else if (speedMult <= 3.0) {
            this.codeLength = 2;
        } else {
            this.codeLength = 1;
        }

        // Generate N-digit code
        this.code = '';
        if (this.isPlayback) {
            this.code = '123';
            this.codeLength = 3;
        } else {
            for (let i = 0; i < this.codeLength; i++) {
                this.code += Math.floor(Math.random() * 10).toString();
            }
        }

        // Display Code
        const codeDisplay = document.createElement('div');
        codeDisplay.textContent = this.code;
        codeDisplay.style.fontSize = '60px';
        codeDisplay.style.color = this.secondaryColor;
        codeDisplay.style.textAlign = 'center';
        codeDisplay.style.letterSpacing = '10px';
        codeDisplay.style.textShadow = `0 0 10px ${this.secondaryColor}`;
        this.container.appendChild(codeDisplay);

        // Input Display
        this.inputDisplay = document.createElement('div');
        this.inputDisplay.style.fontSize = '40px';
        this.inputDisplay.style.color = '#fff';
        this.inputDisplay.style.textAlign = 'center';
        this.inputDisplay.style.height = '50px';
        this.inputDisplay.style.marginTop = '20px';
        this.container.appendChild(this.inputDisplay);

        // Numpad
        const numpad = document.createElement('div');
        numpad.style.display = 'grid';
        numpad.style.gridTemplateColumns = 'repeat(3, 1fr)';
        numpad.style.gap = '10px';
        numpad.style.maxWidth = '300px';
        numpad.style.margin = '20px auto';
        this.container.appendChild(numpad);

        const keys = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
        keys.forEach(i => {
            const btn = document.createElement('button');
            btn.textContent = i;
            btn.className = 'neon-btn';
            // Override neon-btn colors
            btn.style.borderColor = this.primaryColor;
            btn.style.color = this.primaryColor;
            btn.style.boxShadow = `0 0 5px ${this.primaryColor}, inset 0 0 5px ${this.primaryColor}`;

            btn.style.fontSize = '24px';
            btn.style.padding = '15px';
            btn.dataset.playbackKey = `${i}`;
            btn.addEventListener('click', () => this.type(i));
            if (i === 0) {
                btn.style.gridColumn = '2'; // Center the 0
            }
            numpad.appendChild(btn);
        });
    }

    type(num) {
        if (!this.active) return;

        this.input += num;
        this.inputDisplay.textContent = this.input;

        if (this.input.length === this.codeLength) {
            if (this.input === this.code) {
                this.win();
            } else {
                this.lose();
            }
        }
    }
}
